import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const drata = defineConnector({
  identifier: "drata",
  name: "Drata",
  tagLine: "Security compliance automation",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://public-api(\\.eu)?\\.drata\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content: `1. Go to your [Drata API Keys page](https://app.drata.com/account-settings/api-keys)
2. Click “Generate API Key”
3. Give your key a name (e.g., “3B Integration”)
4. Copy the generated API key`,
        },
      ],
    },
    {
      title: "Select your region",
      items: [
        {
          kind: "select",
          label: "Region",
          defaultValue: "public-api.drata.com",
          required: true,
          target: { kind: "configuration", field: "apiHost" },
          options: [
            {
              value: "public-api.drata.com",
              label: "North America (public-api.drata.com)",
            },
            {
              value: "public-api.eu.drata.com",
              label: "European Union (public-api.eu.drata.com)",
            },
          ],
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiHost }) => `https://${apiHost}/public/users`,
  },
});
